import { FocusDto, TranscriptFocus } from '../../../coaching-base/general';
import {
    TagsDialogData,
    TagSetMode,
} from '../../../coaching-tags/tags/tags.model';
import { TranscriptParticipant } from '../../../platform-call';

export function createTagsDialogData(
    participants: TranscriptParticipant[],
    focuses: TranscriptFocus[],
): TagsDialogData {
    const performerUserId = participants?.[0]?.userId;
    const transcriptFocus = focuses?.find((e) => e.isPrimary === true);

    const selected: FocusDto = {
        userId: performerUserId,
        focusId: null,
        behaviourId: transcriptFocus?.behaviourId,
        subBehaviourId: transcriptFocus?.subBehaviourId,
        metrics: [],
    };

    // Todo rename store path
    const data: TagsDialogData = {
        storePathPrefix: 'coaching.transcriptDialogN',
        mode: TagSetMode.FOCUS_ONLY,
        focusSelectionParams: null,
        commitmentId: null,
        performerId: performerUserId,
        selected,
        pinnedMetrics: null,
    };
    return data;
}
